export default function ChatSkeleton({ count = 5 }) {
  return (
    <>
      {Array(count)
        .fill(0)
        .map((_, index) => (
          <div key={index} className="flex items-center space-x-4 p-4">
            <div className="h-12 w-12 rounded-full bg-gray-200 animate-pulse" />
            <div className="space-y-2 flex-1">
              <div className="h-4 w-[200px] bg-gray-200 animate-pulse rounded" />
              <div className="h-4 w-[150px] bg-gray-200 animate-pulse rounded" />
            </div>
          </div>
        ))}
    </>
  );
}
